import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useCategoryPages from '../../hooks/useCategoryPages';
import './CategoryLinks.css';

/**
 * "Browse deals by category": plain links to every /category/:slug page.
 * Besides helping visitors, these are how search engines discover and rank the
 * category pages, so they must stay real <a href> links (not buttons or a <select>).
 */
const CategoryLinks = ({ currentSlug }) => {
  const { categoryPages } = useCategoryPages();
  const links = categoryPages.filter((c) => c.slug !== currentSlug);
  if (links.length === 0) return null;

  return (
    <nav className="category-links" aria-labelledby="category-links-title">
      <h2 id="category-links-title" className="category-links__title">Browse deals by category</h2>
      <ul className="category-links__list">
        {links.map((c) => (
          <li key={c.slug}>
            <Link className="category-links__link" to={`/category/${c.slug}`}>
              {c.name}
              <span className="category-links__count">{c.count}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

CategoryLinks.propTypes = {
  currentSlug: PropTypes.string,
};

export default CategoryLinks;
